<template>
  <div>
    <md-layout md-align="center">
    <md-layout md-flex-xlarge="40" md-flex-large="50" md-flex-medium="60" md-flex-small="80">

      <md-card class="content">
        <md-table >
          <md-table-header>
            <md-table-row>
              <md-table-head><translate>Product</translate></md-table-head>
              <md-table-head><translate>Quantity</translate></md-table-head>
              <md-table-head><translate>Price</translate></md-table-head>
            </md-table-row>
          </md-table-header>

          <md-table-body>
            <md-table-row v-for="(product, index) in order.products" :key="index">
              <md-table-cell class="column">{{ product.name }}</md-table-cell>
              <md-table-cell class="column">{{ product.quantity }}</md-table-cell>
              <md-table-cell class="column"><span v-if="!product.custom">{{ product.quantity * product.price }} € <translate>(incl. VAT)</translate></span></md-table-cell>
            </md-table-row>
          </md-table-body>
        </md-table>
      </md-card>

    </md-layout>
    </md-layout>

    <md-layout md-align="center">
      <md-layout md-flex-xlarge="40" md-flex-large="50" md-flex-medium="60" md-flex-small="80">
        <md-input-container>
          <translate tag="label">Note</translate>
          <md-textarea v-model="order.note"></md-textarea>
        </md-input-container>
      </md-layout>
    </md-layout>

  </div>
</template>

<script>
export default {
  name: 'order-review',
  props: [ 'order' ],
  computed: {
  },
  methods: {
    productRemove (product) {
      this.$emit('removeItem', product)
    },
    productClicked (product, event) {
      event.preventDefault()
      // insert only unique values
      if (!this.doesContain(product)) {
        this.$emit('addItem', {
          'id': product._id,
          'quantity': 1,
          'price': product.price || 0
        })
      }
    }
  }
}
</script>

<style scoped>
.content {
  width: 100%;
  margin-top: 12px;
  margin-bottom: 12px;
  text-align: left;
}
.column {
  font-size: 1.1em;
}
</style>



// WEBPACK FOOTER //
// src/components/order/Review.vue